import React, { memo } from 'react';
import { Select as AntdSelect } from 'antd';
import { SelectValue, SelectProps } from 'antd/lib/select';

import './select.scss';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

const { Option } = AntdSelect;

export interface SelectOption<T = number> {
	label: string | number;
	value: T;
}

export interface SelectedValueProps<T> extends SelectProps<T> {
	dataTestId?: string;
	label?: string;
}

function Select<T extends SelectValue = number>({
	value,
	placeholder,
	options,
	onChange,
	dataTestId,
	label,
	...selectProps
}: SelectedValueProps<T>) {
	return (
		<div className="filter-item" data-test-id={dataTestId}>
			{label && <label className="filters-search-label">{label}:</label>}
			<AntdSelect
				placeholder={placeholder}
				value={value}
				suffixIcon={<BringgIcon iconName={BringgFontIcons.Chevron} />}
				onChange={onChange}
				{...selectProps}
			>
				{options.map(({ value, label }) => (
					// TODO: be aware in case value is Array type the react key won't be setted
					<Option key={value} className="select-option" value={value}>
						{label}
					</Option>
				))}
			</AntdSelect>
		</div>
	);
}

export default memo(Select) as typeof Select;
